var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "184.32pt",
    height: "184.32pt",
    viewBox: "0 0 184.32 184.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient0",
    gradientUnits: "objectBoundingBox",
    x1: 0.306283369503096,
    y1: 0.448436958891535,
    x2: 1.24738268177235,
    y2: 1.05519221309614,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1,
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    gradientUnits: "objectBoundingBox",
    x1: 0.53048741628134,
    y1: 0.0109499900681804,
    x2: 2.02436610198171,
    y2: 1.22226581903499,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1,
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape1",
    transform: "matrix(6.39999923706061 0 0 6.39999923706061 2.22044596101771e-16 8.12399966481336)",
    fill: "url(#gradient0)",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M9.09933 15.7845L0 15.7542L1.17537 13.58L10.2747 13.6103L9.09933 15.7845M18.5938 23.1455C16.4106 25.1089 13.9945 26.0906 11.3454 26.0906C8.43658 26.0906 6.24131 24.8388 4.75959 22.3352C3.27788 19.8315 2.89965 16.7349 3.6249 13.0453C4.35016 9.35573 5.94578 6.25911 8.41176 3.75547C10.8777 1.25182 13.5651 0 16.4739 0C19.3828 0 21.6014 1.29135 23.13 3.87406C23.0908 3.94699 23.4527 3.19813 24.2156 1.6275C24.1458 5.37321 24.0895 7.28571 24.0469 7.365C23.9878 7.47495 22.9847 7.62495 21.0375 7.815C21.6801 6.58749 21.9845 6.00518 21.9507 6.06805C20.5598 3.47216 18.5918 2.17422 16.0466 2.17422C13.6572 2.17422 11.4242 3.22839 9.34758 5.33672C7.27096 7.44505 5.93478 10.0146 5.33904 13.0453C4.74329 16.076 5.0693 18.6456 6.31706 20.7539C7.56482 22.8622 9.3834 23.9164 11.7727 23.9164C12.1755 23.9164 14.0009 23.4889 15.75 22.5244C16.916 21.8813 17.7972 20.897 18.3937 19.5713C15.1612 19.6163 15.4753 18.8288 15.4406 18.0806C15.4815 17.374 16.8675 18.2063 18.8156 17.7713L19.2656 16.1681C15.7388 16.155 15.945 15.6487 16.2281 14.7056C16.2843 14.4018 16.2234 14.2941 19.7016 14.3259L19.7718 13.9463C19.4209 12.7466 17.8596 7.95422 15.6656 7.95563C14.487 7.95638 12.1726 7.62367 11.4188 9.69938C10.9162 11.0832 13.7594 12.0214 14.7094 12.2869C15.6593 12.5524 18.5886 13.1155 17.4938 16.5056C16.399 19.8957 13.1619 20.6857 10.2656 20.3588C7.3693 20.0319 6.35077 17.1336 7.425 16.4494C8.49923 15.7652 8.95757 17.7763 10.2375 18.4463C11.5174 19.1162 13.7376 19.6163 15.4406 16.9838C16.576 15.2287 15.6385 14.16 12.6281 13.7775C9.17479 12.6616 8.18104 11.0585 9.64688 8.96813C11.8456 5.83261 15.6586 6.44381 16.0031 6.40875C15.8344 5.28375 16.0031 6.40875 16.0031 6.40875C18.1349 6.54159 19.6802 8.66827 20.0813 9.47438C20.7556 10.8299 20.9749 10.9709 21.4031 12.1744C24.3636 7.9316 27.2907 5.87625 28.4063 6.43688C28.5299 6.77704 23.1817 12.6526 22.1906 14.1713C23.7581 14.5238 27.0435 13.6067 26.9156 14.2838C26.745 15.3731 24.9918 16.0013 21.6562 16.1681L21.375 17.6306C22.5562 18.0525 26.457 16.8465 26.1562 17.7713C25.7943 18.8344 23.713 19.458 20.7843 19.4306C20.5587 20.5967 19.8285 21.835 18.5938 23.1455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shape0",
    transform: "matrix(0.999999960263572 0 0 0.999999960263572 63.4261159271675 32.8174094720218)",
    fill: "url(#gradient1)",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M24.0539 38.2826C21.8939 48.3626 14.6939 76.8026 10.9139 86.8826C7.13389 96.9626 -2.94611 117.303 0.833885 118.023C4.61389 118.743 11.4539 116.043 19.0139 90.8426C26.5739 65.6426 33.2339 43.6826 36.1139 30.7226C38.9939 17.7626 40.2539 9.84259 38.6339 5.88259C37.0139 1.92259 34.4939 -0.597409 32.8739 0.122591C31.2539 0.842591 31.2539 0.122591 28.7339 6.06259C26.2139 12.0026 27.1139 25.1426 26.2139 30.0026C25.3139 34.8626 25.3139 34.8626 24.0539 38.2826Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.187c4341e5275584ac96ca690f61c547.svg";
export { ForwardRef as ReactComponent };